var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 7,
  width: 31,
  height: 31,
  rx: 1.5,
  fill: "#4a77b8"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.5,
  y: 8.5,
  width: 8.6,
  height: 28,
  rx: 0.8,
  fill: "#5a8fd8"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.2,
  y: 8.5,
  width: 8.6,
  height: 28,
  rx: 0.8,
  fill: "#5a8fd8"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 27.9,
  y: 8.5,
  width: 8.6,
  height: 28,
  rx: 0.8,
  fill: "#5a8fd8"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 10.3,
  y: 10.5,
  width: 5,
  height: 2.6,
  rx: 0.6,
  fill: "#dfe6ec"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 10.5,
  width: 5,
  height: 2.6,
  rx: 0.6,
  fill: "#dfe6ec"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 29.7,
  y: 10.5,
  width: 5,
  height: 2.6,
  rx: 0.6,
  fill: "#dfe6ec"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m10.3 15.5h5m-5 2.3h5",
  stroke: "#2e4057",
  strokeWidth: 1,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m20 15.5h5m-5 2.3h5",
  stroke: "#2e4057",
  strokeWidth: 1,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m29.7 15.5h5m-5 2.3h5",
  stroke: "#2e4057",
  strokeWidth: 1,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 15.3,
  y: 22,
  width: 1.4,
  height: 3.6,
  rx: 0.7,
  fill: "#2e4057"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 22,
  width: 1.4,
  height: 3.6,
  rx: 0.7,
  fill: "#2e4057"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 34.7,
  y: 22,
  width: 1.4,
  height: 3.6,
  rx: 0.7,
  fill: "#2e4057"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.2,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

function SvgLockers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockers);
export default __webpack_public_path__ + "static/media/lockers.c7f8d8c42cf11ab2f333a29504dddd03.svg";
export { ForwardRef as ReactComponent };